import { render, staticRenderFns } from "./CartItemsCount.vue?vue&type=template&id=7387e836&lang=pug"
import script from "./CartItemsCount.vue?vue&type=script&lang=js"
export * from "./CartItemsCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/santiagomunguia/Documents/www/skinfix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7387e836')) {
      api.createRecord('7387e836', component.options)
    } else {
      api.reload('7387e836', component.options)
    }
    module.hot.accept("./CartItemsCount.vue?vue&type=template&id=7387e836&lang=pug", function () {
      api.rerender('7387e836', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/cart/CartItemsCount.vue"
export default component.exports